import { all } from 'redux-saga/effects'

import { statisticsSaga } from './statistics/sagas'
import { candidatesSaga } from './candidates/sagas'

export function* jobSaga() {
  yield all([statisticsSaga(), candidatesSaga()])
}
